/* eslint-disable max-lines */

import { fetchSingleCustomer } from 'actions/auth';
import reduceWidgetGroup from 'components/Dashboard/reduceWidgetGroup';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getCustomer, getSpoofedUserUuid, getUser } from 'selectors/auth';
import { useSelector } from 'store';
import { DashboardWidget as DashboardWidgetType } from 'types';

const ReviewSetsHeader: React.FC = () => {
  // const user = useSelector(getUser);
  const dispatch = useDispatch();
  const customer = useSelector(getCustomer);
  const user = useSelector(getUser);
  const spoofedUserUuid = useSelector(getSpoofedUserUuid);

  const retentionDays = customer.config?.communication_retention_days || 0;

  useEffect(() => {
    if (Object.keys(customer).length === 0) {
      dispatch(fetchSingleCustomer);
    }
  }, [dispatch, customer]);

  // const REVIEW_SET_METRICS = [
  //   {
  //     columns_start: 1,
  //     columns_width: 24,
  //     rows_start: 1,
  //     rows_height: 1,
  //     type: 'statistic',
  //     time_range: '-9999days',
  //     widget: 'review_set_metrics',
  //     container_class_name: 'rounded-md block',
  //     use_cache: false,
  //     metrics: [
  //       {
  //         id: 'in_progress',
  //         label: 'Open',
  //         metric: 'saved_searches',
  //         namespace: 'Litlingo',
  //         dimensions: [
  //           {
  //             name: 'record_count',
  //             value: '0',
  //             relational_operator: 'greater_than',
  //             logical_operator: 'AND',
  //           },
  //           {
  //             name: 'closed_by',
  //             value: 'None',
  //             logical_operator: 'AND',
  //           },
  //           { name: 'assignment_user_uuid', value: user.uuid, logical_operator: 'AND' },
  //           { name: 'user_uuid', value: user.uuid, logical_operator: 'AND' },
  //         ],
  //       },
  //       {
  //         id: 'completed',
  //         label: 'Done',
  //         metric: 'saved_searches',
  //         namespace: 'Litlingo',
  //         dimensions: [
  //           {
  //             name: 'record_count',
  //             value: '0',
  //             logical_operator: 'AND',
  //           },
  //           { name: 'user_uuid', value: user.uuid, logical_operator: 'AND' },
  //         ],
  //       },
  //     ],
  //   },
  // ];

  const EXPIRING_MESSAGES = [
    {
      widget: 'table_two_widget',
      columns_start: 1,
      columns_width: 24,
      rows_start: 1,
      rows_height: 4,
      type: 'sent_at',
      metrics: [
        {
          id: 'out_of_retention_pending',
          namespace: 'Litlingo',
          metric: 'total_lead',
          label: 'Higher Risk Pending',
          dimensions: [
            {
              name: 'assigned_to_me',
              value: 'true',
            },
            {
              name: 'review_value',
              value: 'pending',
            },
            {
              name: 'campaign',
              value: '8e09c0d2-dc34-5e85-96c4-40e60a48890e',
            },
          ],
          group_by: 'expires_at',
          unit_of_time: 'months',
          opensearch_enabled: true,
        },
        {
          id: 'out_of_retention_escalated',
          namespace: 'Litlingo',
          metric: 'total_lead',
          label: 'Escalated',
          dimensions: [
            {
              name: 'assigned_to_me',
              value: 'true',
            },
            {
              name: 'review_value',
              value: 'escalated',
            },
          ],
          group_by: 'expires_at',
          unit_of_time: 'months',
          opensearch_enabled: true,
        },
      ],
      title: '',
      subtitle: '',
      container_class_name: 'flex flex-col justify-between h-full w-full bg-white',
      export_label: 'Expiring Messages',
    },
  ];

  const HIGHER_RISK_RESOLVED = [
    {
      widget: 'higher_risk_resolved',
      columns_start: 1,
      columns_width: 24,
      rows_start: 1,
      rows_height: 4,
      type: 'sent_at',
      metrics: [
        {
          id: 'activity_2',
          namespace: 'Litlingo',
          metric: 'total',
          type: null,
          label: 'Events',
          icon: null,
          dimensions: [
            {
              name: 'review_value',
              value: 'out_of_policy',
            },
            {
              name: 'review_value',
              value: 'escalated',
            },
            {
              name: 'campaign',
              value: '8e09c0d2-dc34-5e85-96c4-40e60a48890e',
            }, // TODO: ask andy if we need this filter or if it should just be whatevers assigned
            {
              name: 'reviewed_by',
              value: spoofedUserUuid || user.uuid,
            },
          ],
          group_by: null,
          limit: null,
          unit_of_time: null,
          opensearch_enabled: true,
        },
        {
          id: 'activity_2_platform_o365',
          namespace: 'Litlingo',
          metric: 'total',
          label: 'Events Outlook',
          icon: 'outlook',
          dimensions: [
            {
              name: 'review_value',
              value: 'out_of_policy',
            },
            {
              name: 'campaign',
              value: '8e09c0d2-dc34-5e85-96c4-40e60a48890e',
            }, // TODO: ask andy if we need this filter or if it should just be whatevers assigned
            {
              name: 'reviewed_by',
              value: spoofedUserUuid || user.uuid,
            },
            // if isLegalUser add the tag values
          ],
          group_by: null,
          limit: null,
          unit_of_time: null,
          opensearch_enabled: true,
        },
        {
          id: 'activity_2_platform_teams',
          namespace: 'Litlingo',
          metric: 'total',
          type: null,
          label: 'Events Teams',
          icon: 'teams',
          dimensions: [
            {
              name: 'review_value',
              value: 'in_policy',
            },

            {
              name: 'campaign',
              value: '8e09c0d2-dc34-5e85-96c4-40e60a48890e',
            },
            {
              name: 'reviewed_by',
              value: spoofedUserUuid || user.uuid,
            },
          ],
          group_by: null,
          limit: null,
          unit_of_time: null,
          opensearch_enabled: true,
        },
      ],
      title: '',
      subtitle: '',
      container_class_name: 'flex flex-col justify-between h-full w-full bg-white',
      export_label: 'Expiring Messages',
    },
  ];

  return (
    <div
      className="flex flex-col gap-4 h-full w-full pt-10 pb-10 px-6 bg-white"
      style={{
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      }}
    >
      <div className="h-19 flex flex-row gap-4 items-start justify-between">
        <div className="flex flex-row justify-between items-center">
          <span className="whitespace-no-wrap text-heading-1">My Assignments</span>
        </div>
        {/* <div className="flex-1 max-w-56 grid grid-cols-24 items-stretch h-full">
          {REVIEW_SET_METRICS.reduce<(JSX.Element | DashboardWidgetType)[]>(
            reduceWidgetGroup(null, 'review_set_metric_widget'),
            []
          )}
        </div> */}
      </div>
      {retentionDays > 0 && (
        <div className="h-36 w-full grid grid-cols-24 items-stretch">
          {EXPIRING_MESSAGES.reduce<(JSX.Element | DashboardWidgetType)[]>(
            reduceWidgetGroup(null, 'expiring_messages'),
            []
          )}
        </div>
      )}
      <div className="h-36 w-full grid grid-cols-24 items-stretch">
        {HIGHER_RISK_RESOLVED.reduce<(JSX.Element | DashboardWidgetType)[]>(
          // @ts-ignore
          reduceWidgetGroup(null, 'higher_risk'),
          []
        )}
      </div>
    </div>
  );
};

export default ReviewSetsHeader;
